import { fillableElements, FormRestructureEvent } from "../core/";

/**
 * Force HTMLElements with the `required`
 * @param {HTMLFormElement} form 
 */
export function addForceRequired(form) {
  form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

    for (const entry of event.added) {
      if (!entry.field) continue;

      for (const node of entry.field.querySelectorAll(`:scope :is(${fillableElements})[required]:not(.required)`)) {
        const element = /** @type {HTMLElement} */ (node);
        element.classList.add("required");
        if (!element.hasAttribute("aria-required")) {
          element.setAttribute("aria-required", "true");
        }
      }
    }
  });
}
